import React from 'react';
import { getMediaURL } from "../../../../config/values";
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../config/design/styles";
import { useMediaQuery } from '@mui/material'; // Import useMediaQuery and Theme

function BannerSliderItem({ banner, classes }) {
    // Use the useMediaQuery hook to check if the screen size is medium (md) or below
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md')); // Adjust breakpoint as needed

    return (
        <div className={classes.bannerSliderItem}>
            <a href={banner.link}>
                <img
                    loading="lazy"
                    src={getMediaURL(isMobile ? banner.mobile_image : banner.desktop_image)}
                    alt={isMobile ? banner.mobile_image?.alt : banner.desktop_image?.alt}
                />
            </a>
        </div>
    );
}

export default withStyles(Styles)(BannerSliderItem);